import { initializeFaro, ErrorsInstrumentation, WebVitalsInstrumentation } from '@grafana/faro-web-sdk';
import pkg from '../package.json';

const appVersion = pkg.version;

const APP_NAME = 'smartbet-live-display';

let faro = null;
let shop = 'unknown';
let screen = 'unknown';
let deviceId = 'unknown';
let lastBufferAt = 0;
let lastBatchSize = 0;
let socketConnected = false;

const str = (v) => (v === null || v === undefined ? '' : String(v));

const stringMap = (obj) =>
  Object.fromEntries(Object.entries(obj || {}).map(([k, v]) => [k, str(v)]));

function readParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    shop = (params.get('shop') || 'unknown').slice(0, 40);
    screen = (params.get('screen') || 'unknown').slice(0, 40);
  } catch {
    shop = 'unknown';
    screen = 'unknown';
  }
}

function readDeviceId() {
  try {
    const key = 'live_display_device_id';
    let id = localStorage.getItem(key);
    if (!id) {
      id = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : `dev-${Date.now()}`;
      localStorage.setItem(key, id);
    }
    deviceId = id;
  } catch {
    deviceId = `dev-${Date.now()}`;
  }
}

export function initFaro() {
  if (faro) return faro;
  readParams();
  readDeviceId();
  try {
    faro = initializeFaro({
      url: `${window.location.origin}/faro/collect`,
      app: {
        name: APP_NAME,
        version: appVersion,
        environment: process.env.NODE_ENV || 'production',
      },
      user: { id: deviceId, attributes: { shop, screen } },
      instrumentations: [new ErrorsInstrumentation(), new WebVitalsInstrumentation()],
      sessionTracking: { enabled: true },
    });
    faro.api.pushEvent('screen_start', {
      shop,
      screen,
      device_id: deviceId,
      url: window.location.href,
    });
    console.log('[faro] initialised', { shop, screen, deviceId });
  } catch (e) {
    console.warn('[faro] init failed', e);
  }
  return faro;
}

export function faroLog(level, message, context) {
  try {
    faro?.api.pushLog([message], { level, context: stringMap(context) });
  } catch {}
}

export function faroError(error, context) {
  try {
    faro?.api.pushError(error instanceof Error ? error : new Error(String(error)), {
      context: stringMap(context),
    });
  } catch {}
}

export function faroEvent(name, attributes) {
  try {
    faro?.api.pushEvent(name, stringMap(attributes));
  } catch {}
}

export function markBuffer(size) {
  lastBufferAt = Date.now();
  if (size !== undefined) lastBatchSize = size;
}

export function markDiff() {
  lastBufferAt = Date.now();
}

export function setSocketConnected(value) {
  socketConnected = !!value;
}

export function startHeartbeat() {
  if (window.__faroHeartbeat) return;
  window.__faroHeartbeat = setInterval(() => {
    faroLog('info', 'heartbeat', {
      shop,
      screen,
      device_id: deviceId,
      socket_connected: socketConnected,
      buffer_age_sec: lastBufferAt ? Math.round((Date.now() - lastBufferAt) / 1000) : 'none',
      last_batch: lastBatchSize,
      url: window.location.href,
    });
  }, 30000);
}
